import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as auth from 'core/auth';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountCorporateComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Prop()
    user: api.UserAccount;
}
